import { useState } from "react"
import { Box, Typography } from '@mui/material'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'

import Minesweeper from "./projects/Minesweeper"
// import Hangman from "./projects/Hangman"
// import BaseLoginApp from "./projects/BaseLoginApp"
import Steganography from "./projects/Steganography"
// import EventManager from "./projects/EventManager"
import Quiz from './projects/Quiz'
import TwoRuns from "./projects/TwoRuns"
import ProductDatabaseIntegration from "./projects/ProductDatabaseIntegration"
import WebsiteRedesign from "./projects/WebsiteRedesign"
import './Carousel.css'


const Projects = () => {
  const [openPDI, setOpenPDI] = useState(false)
  const [openMinesweeper, setOpenMinesweeper] = useState(false)
  // const [openHangman, setOpenHangman] = useState(false)
  // const [openBLA, setOpenBLA] = useState(false)
  const [openSteg, setOpenSteg] = useState(false)
  // const [openEvent, setOpenEvent] = useState(false)
  const [openQuiz, setOpenQuiz] = useState(false)
  const [openTwoRuns, setOpenTwoRuns] = useState(false)
  const [openWebRedesign, setOpenWebRedesign] = useState(false)

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 10
    },
    qhd: {
      breakpoint: { max: 3000, min: 2000 },
      items: 7
    },
    desktop: {
      breakpoint: { max: 2000, min: 1200 },
      items: 5
    },
    largeTablet: {
      breakpoint: { max: 1200, min: 800 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 800, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  }


  return (
    <Box sx={{
      marginTop: '5rem',
      width: '100vw',
      backgroundColor: '#635985',
    }}>
      <Typography variant="h4" sx={{ color: '#EDEBF7', textAlign: 'center', mt: 2 }}>
        <strong style={{ fontStyle: 'italic' }}>My </strong>Projects
      </Typography>
      <Carousel
        swipeable={!openPDI && !openMinesweeper && !openSteg && !openQuiz && !openTwoRuns && !openWebRedesign}
        draggable={!openPDI && !openMinesweeper && !openSteg && !openQuiz && !openTwoRuns && !openWebRedesign}
        showDots={false}
        responsive={responsive}
        containerClass="carousel-container center-carousel"
        itemClass="carousel-item-padding-40-px"
      >
        <ProductDatabaseIntegration openPDI={openPDI} setOpenPDI={setOpenPDI} />
        <WebsiteRedesign openWebRedesign={openWebRedesign} setOpenWebRedesign={setOpenWebRedesign} />
        <Minesweeper openMinesweeper={openMinesweeper} setOpenMinesweeper={setOpenMinesweeper} />
        <Steganography openSteg={openSteg} setOpenSteg={setOpenSteg} />
        {/* <BaseLoginApp openBLA={openBLA} setOpenBLA={setOpenBLA} /> */}
        <Quiz openQuiz={openQuiz} setOpenQuiz={setOpenQuiz} />
        {/* <EventManager openEvent={openEvent} setOpenEvent={setOpenEvent} /> */}
        <TwoRuns openTwoRuns={openTwoRuns} setOpenTwoRuns={setOpenTwoRuns} />
        {/* <Hangman openHangman={openHangman} setOpenHangman={setOpenHangman} /> */}
      </Carousel>
      <Typography variant="body1" sx={{ color: '#EDEBF7', textAlign: 'center', my: 2, fontStyle: 'italic', mx: 1 }}>
        <strong style={{ fontStyle: 'italic' }}>Note: </strong>Most of my repositories are private, but if you are hiring, email me and I will gladly share them with you.
      </Typography>
    </Box>
  )
}

export default Projects